/** Allowed off-wing values in forms and detach flow. */
export const OFF_WING_TYPE_OPTIONS = [
  "In Shop",
  "Serviceable - Spare",
  "Unserviceable - Spare",
] as const;

export type OffWingTypeOption = (typeof OFF_WING_TYPE_OPTIONS)[number];

const DEFAULT_OFF_WING: OffWingTypeOption = "In Shop";

/**
 * Maps API/legacy values onto allowed options so MUI Select always has a matching value.
 */
export function normalizeOffWingTypeForForm(
  value: string | undefined | null
): OffWingTypeOption {
  const v = (value ?? "").trim();
  if (v === "In Shop") {
    return "In Shop";
  }
  if (v === "Unserviceable - Spare" || v === "Unserviceable - Part") {
    return "Unserviceable - Spare";
  }
  if (v === "Serviceable - Spare" || v === "Serviceable - Part") {
    return "Serviceable - Spare";
  }
  return DEFAULT_OFF_WING;
}

export function formatOffWingTypeLabel(
  value: string | undefined | null
): string {
  return normalizeOffWingTypeForForm(value);
}

export function getComponentOffWingType(component: {
  customMetadata?: Record<string, unknown>;
}): OffWingTypeOption {
  const meta = component.customMetadata;
  const raw =
    meta?.offWingType ?? meta?.OffWingType ?? meta?.OffWingStatus;
  return normalizeOffWingTypeForForm(
    raw != null ? String(raw) : undefined
  );
}
